import * as React from 'react';

const CheckCircleFilled32 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#CheckCircleFilled32__a)" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16 0C7.166 0 0 7.166 0 16s7.166 16 16 16 16-7.166 16-16S24.834 0 16 0m-1.596 21.281-5.438-5.437 1.273-1.272 4.165 4.165 7.37-7.37 1.272 1.272z"
  }
)), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "CheckCircleFilled32__a" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h32v32H0z" }))));
CheckCircleFilled32.Size = 32;
CheckCircleFilled32.Title = "CheckCircleFilled";

export { CheckCircleFilled32 as default };
